import { findIndex } from "lodash";
//import sendxAPI from '../../../xAPI'

const templateState = {
  id: -1,
  type: null,
  held: false,
  inScene: true
};

export function PlantReducer(
  state = { plants: [] },
  action
) {
  let currentPlant;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
    return state;
  }

  if (
    action.type !== "CREATE_PLANT" &&
    !action.type.includes("@redux")
  ) {
    if (action.payload.hasOwnProperty("id")) {
      if (
        state.protocolSection.scene.apparatus.hasOwnProperty("plants")
      ) {
        currentPlant =
          state.protocolSection.scene.apparatus.plants[
            findIndex(state.protocolSection.scene.apparatus.plants, {
              id: action.payload.id,
            })
          ];
      }
    }
  }

  switch (action.type) {
    case "CREATE_PLANT":
      //Create new obj from template state
      let newObj = { ...templateState, ...action.payload.props };

      if (protocolSection.scene.apparatus.hasOwnProperty("plants")) {
        protocolSection.scene.apparatus.plants = [
          ...protocolSection.scene.apparatus.plants,
          newObj,
        ];
      } else {
        protocolSection.scene.apparatus.plants = [newObj];
      }

      return {
        ...state,
        ...{
          protocolSection: protocolSection,
        },
      };

    case "SET_PLANT_HELD":
      currentPlant.held = action.payload.held;
      protocolSection.scene.apparatus.plants[findIndex(state.protocolSection.scene.apparatus.plants, { id: action.payload.id })] = currentPlant;
      return { ...state, ...{ protocolSection: protocolSection } };
      
    case "SET_PLANTS_IN_SCENE":
    //Payload = {inScene}
    currentPlant.inScene = action.payload.inScene;
    protocolSection.scene.apparatus.plants[findIndex(state.protocolSection.scene.apparatus.plants, { id: action.payload.id })] = currentPlant;
    return { ...state, ...{ protocolSection: protocolSection } };
    
    case "UNDO":
      //Payload = {lastState}

      if (action.payload.lastState !== null && protocolSection.scene.apparatus.hasOwnProperty('plants')) {
        protocolSection.scene.apparatus.plants =
          action.payload.lastState.scene.apparatus.plants;

        return {
          ...state,
          ...{
            protocolSection: protocolSection,
          },
        };
      } else {
        return state;
      }

    default:
      return state;
  }
}
